import { IkeaProductCard } from './interfaces';

const fetchIkeaProductFeed = async (
  node_locale: string,
  businessUnitCode?: string,
  primaryLanguage?: string,
  numberOfItem?: number,
): Promise<IkeaProductCard[]> => {
  try {
    const response = await fetch('/api/ikea-products', {
      method: 'POST',
      body: JSON.stringify({
        locale: node_locale,
        businessUnitCode: businessUnitCode || '',
        primaryLanguage: primaryLanguage || node_locale,
        numberOfItem: numberOfItem,
      }),
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    if (response.ok) {
      const result = await response.json();
      return (result.data || result) as IkeaProductCard[];
    } else {
      console.error('Error fetching IKEA products:', response.statusText);
      return [];
    }
  } catch (error) {
    console.error('Error fetching IKEA products:', error);
    return [];
  }
};

export default fetchIkeaProductFeed;
